import OutlinedFlagIcon from "@mui/icons-material/OutlinedFlag";
import { Box, useTheme } from "@mui/material";
import DataTable from "app/components/DataTable";
import clsx from "clsx";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { selectWorkOrderStatusKey } from "../../../redux/selector";
import { CustomerWorkOrder } from "../../../types";
import { useStyles } from "./styles";

type Props = {
  rows: CustomerWorkOrder[];
};

const WorkOrder = ({ rows }: Props) => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const theme = useTheme();

  const columns = useMemo(
    () => [
      {
        id: "priority",
        label: t("CUSTOMERS.DETAILS.WORK_ORDERS.TABLE.PRIORITY"),
        minWidth: 100,
        align: "right",
        format: (row: CustomerWorkOrder) => (
          <Box className={styles.priorityCell}>
            <OutlinedFlagIcon
              className={clsx(
                styles.priorityIcon,
                styles[`priority${row.priority}`]
              )}
            />
            <span>
              {t(`CUSTOMERS.DETAILS.WORK_ORDERS.PRIORITY.${row.priority}`)}
            </span>
          </Box>
        ),
      },
      {
        id: "progress",
        label: t("CUSTOMERS.DETAILS.WORK_ORDERS.TABLE.PROGRESS"),
        minWidth: 90,
        align: "right",
        format: (row: CustomerWorkOrder) => `${row.progress}%`,
      },
      {
        id: "currentStage",
        label: t("CUSTOMERS.DETAILS.WORK_ORDERS.TABLE.CURRENT_STAGE"),
        minWidth: 140,
        align: "right",
        format: (row: CustomerWorkOrder) =>
          t(`CUSTOMERS.DETAILS.WORK_ORDERS.STAGE.${row.currentStage}`),
      },
      {
        id: "vehicleKey",
        label: t("CUSTOMERS.DETAILS.WORK_ORDERS.TABLE.VEHICLE"),
        minWidth: 200,
        align: "right",
        format: (row: CustomerWorkOrder) => t(row.vehicleKey),
      },
      {
        id: "status",
        label: t("CUSTOMERS.DETAILS.WORK_ORDERS.TABLE.STATUS"),
        minWidth: 110,
        align: "right",
        format: (row: CustomerWorkOrder) => (
          <span
            className={styles.statusChip}
            style={{
              backgroundColor: theme.palette.workOrderStatus[row.status],
            }}
          >
            {t(selectWorkOrderStatusKey(row.status))}
          </span>
        ),
      },
      {
        id: "workOrderId",
        label: t("CUSTOMERS.DETAILS.WORK_ORDERS.TABLE.ID"),
        minWidth: 100,
        align: "right",
      },
    ],
    [styles, t, theme]
  );

  return (
    <Box className={styles.root} dir={i18n.dir()}>
      <DataTable
        rows={rows}
        columns={columns}
        serialEnabled={false}
        noDataLabel={t("CUSTOMERS.DETAILS.WORK_ORDERS.EMPTY")}
      />
    </Box>
  );
};

export default WorkOrder;
